<template>
  <div class="auth">
    <div class="auth-container">
      <div class="auth-header">
        <div class="title">sphinx</div>
      </div>
      <form @submit.prevent="login" class="auth-form" method="POST">
        <div class="form-groups">
          <div class="form-group">
            <input
              v-model="handler"
              class="auth-input"
              name="handler"
              type="text"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <input
              v-model="secret"
              class="auth-input"
              name="secret"
              type="password"
              autocomplete="off"
            />
          </div>
        </div>
        <div v-if="error" class="inputErrorContainer">
          <div class="inputErrorText">{{ error }}</div>
        </div>
        <div class="submit">
          <input
            :disabled="submitting"
            class="auth-button"
            type="submit"
            :value="loginText"
          />
        </div>
      </form>
      <div class="auth-alt-buttons"></div>
    </div>
  </div>
</template>

<script>
import auth from "../../api/auth";

export default {
  name: "LoginPage",
  data() {
    return {
      handler: "",
      secret: "",
      error: "",
      submitting: false,
      success: false,
      loginText: "enter",
    };
  },

  methods: {
    async login() {
      this.submitting = true;
      this.loginText = "Logging in...";
      try {
        const { handler, secret } = this;

        await auth.login({ handler, secret });

        this.error = "";
        this.$router.push("/");
      } catch (error) {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 400)
        ) {
          this.error = error.response.data.error;
          console.log("@login here");
        } else {
          console.log("internal server error");
        }
      } finally {
        this.submitting = false;
        this.loginText = "Login";
      }
    },
  },
};
</script>

<style scoped>
.external-auth {
  padding: 10px;
}

.title {
  font-size: 52px;
  line-height: 74px;
  font-weight: bold;
  color: #252525;
  /* position: absolute; */
  display: block;
  /* left: 0; */
  right: 0;
  top: 135px;
  margin: 0 auto;
  width: 272px;
  cursor: default;
}

.title:hover {
  color: #37373a;
}

.auth {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.auth-container {
  max-width: 350px;
  width: 325px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 130px;
}
.auth-form {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  position: relative;
}
.auth-header {
  margin-bottom: 30px;
}
.auth-title {
  font-size: 42px;
  font-weight: bold;
  color: #252525;
  display: block;
  margin-top: 65px;
}

.auth-title:hover {
  color: #37373a;
}

.auth-subtitle {
  color: #252525;
  font-size: 22px;
  /* font-weight: bold; */
  width: 330px;
  margin: 0 auto;
  line-height: 22px;
  font-family: "Nunito";
  margin-top: 5px;
}
.auth-input {
  width: 100%;
  border: none;
  border: 1px solid #ececec;
  border-radius: 3px;
  caret-color: #666;
  padding: 8px 19px;
  font-size: 20px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
  border-radius: 360px;
}
.auth-input:focus,
.auth-input:hover {
  border-color: #dcdcdc;
}
.auth-button {
  outline: none;
  background-color: #252525;
  color: white;
  font-size: 23px;
  font-weight: bold;
  border: unset;
  padding: 6px;
  width: 95%;
  cursor: pointer;
  font-family: "Nunito", sans-serif;
  margin-top: 8px;
  border-radius: 360px;
}
.auth-button:hover {
  background-color: #37373a;
}
.auth-alt-buttons {
  display: flex;
  flex-direction: column;
}

.auth-helper-button {
  margin-bottom: 15px;
  margin-top: -5px;
  text-align: left;
  color: #252525;
  padding-left: 5px;
}

.auth-helper-button:hover {
  color: #5f5f61;
}
.auth-alt-button {
  color: #252525;
  /* display: block; */
  margin-top: 12px;
}
.auth-alt-button:visited {
  color: #252525;
}
.auth-alt-button:hover {
  color: #5f5f61;
}

.inputErrorContainer {
  padding: 8px 0px;
  background-color: #f9f9f9;
  border-radius: 360px;
  margin-bottom: 5px;
  color: #a72143;
  font-weight: 600;
}

.form-groups {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  justify-content: center;
  position: relative;
}

.success {
  display: block;
  background-color: #eee;
  padding: 5px;
  color: #252525;
  font-size: 17px;
  font-weight: bold;
  border-radius: 360px;
  width: 280px;
  margin: 0 auto;
  margin-bottom: 18px;
  cursor: default;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>